// @flow
import React from 'react';
import type {Node} from 'react';
import {Link} from 'react-router-dom';
import style from './Course.module.css';
import correct from '../ModuleComponent/assets/checked.svg'
import type {
  ResourcesType,
  ModuleComponentType,
  // MultiChoiceFieldsType,
  // LessonFieldsType,
  CourseFieldsType,
  ModuleStatusesType,
  TranslateType,
} from '../../types.js';

type CourseModuleElementType = {
  title: string,
  moduleId: string,
  courseId: string,
  moduleComponents: Array<ModuleComponentType | {}>,
  moduleStatus: boolean,
  number: number,
};

const CourseModuleElement = ({
  title,
  courseId,
  moduleId,
  moduleComponents,
  moduleStatus,
  number,
}: CourseModuleElementType): Node => (
  <Link to={`/course/${courseId}/${moduleId}`} className={style.module}>
    <div className={`${style.moduleTitle} fontBrown`}><span className={style.first}>{number}.</span> {title}</div>
      <div
          className={style.courseStatus}
          style={{
              color: moduleStatus ? 'green' : 'red'
          }}
      >{moduleStatus ? <img alt='' className={style.answerIcon} src={correct}/> : null}</div>
  </Link>
);


// ✔✗

type CoursePresentationType = {
  title: Array<{value: string}>,
  field_introduction: Array<{value: string}>,
  t: TranslateType,
};

export const CoursePresentation = ({
  title,
  field_introduction,
  t,
}: CoursePresentationType): Node => (
  <div className={style.introduction}>
    <div className={`${style.about} fontTisa`} dangerouslySetInnerHTML={{
      __html: field_introduction[0].value,
    }} />
  </div>
);

type CourseModulesPresentationType = {
  courseData: CourseFieldsType,
  resources: ResourcesType,
  moduleStatuses: ModuleStatusesType,
};



export const CourseModulesPresentation = ({
  courseData,
  resources,
  moduleStatuses,
}: CourseModulesPresentationType
): Node => (
  courseData.field_modules.map((
    module: {target_id: string},
    i: number
  ): Node => {
    return <CourseModuleElement
      key={i}
      title={resources.modules[module.target_id].title[0].value}
      moduleId={module.target_id}
      courseId={courseData.nid[0].value}
      moduleStatus={moduleStatuses[module.target_id]}
      number={i + 1}
      moduleComponents={
        resources.modules[module.target_id].field_add_components.map(
          (component: {target_id: string}): {} | ModuleComponentType =>
            resources.components[component.target_id]
        )
      } />;
    }
  )
);

type CourseAssessmentType = {
  courseId: string,
  completed: boolean,
  courseTitle: string,
  t: TranslateType,
};

export const CourseAssessment = ({
  courseId,
  completed,
  courseTitle,
  t,
}: CourseAssessmentType): Node => (
  <Link className={style.module} to={`/course/${courseId}/assessment`}>
    <div className={`${style.moduleTitle} fontBrown`}>{courseTitle} {t('assessment')}</div>
    <div
        className={style.courseStatus}
    >{completed ? <img alt='answer icon' className={style.answerIcon} src={correct}/> : null}</div>
  </Link>
);

const Title = ({title}: {title: string}): Node => <h1 className={`${style.courseHeader} fontTisa`}>{title}</h1>;
const Progress = ({
  complete,
  total,
  t,
}: {complete: number, total: number, t: TranslateType,}): Node => {
  return (
    <div className={`${style.progress} fontTisa`}>
      {parseInt((complete / total) * 100, 10)}%
    </div>
  );
};

export const CourseHeader = ({
  title,
  progress,
}: {
  title: string,
  progress: {
    total: number,
    complete: number,
  },
}): Node => (
  <div className={style.header}>
    <Title title={title} />
    <Progress complete={progress.complete} total={progress.total} />
  </div>
);

type CourseResourceType = {
    data: Array<{
        title: string,
        url: string,
    }>,
    t: TranslateType,
};


export const CourseResource = ({
  data,
  t,

}: CourseResourceType): Node => (
    <div>
    {
        data.length > 3
            ?
            <div className={`${style.resources}`}>
                <div className={'tab'}>
                    <input className={'tabOne'} type="checkbox" name="tabs" />
                    <label className={'fontTisa'} htmlFor={'tab-one'}>{t('resources')}</label>
                    <div className={'tabContent'}>
                        <ul>
                            {data.map((item, i) => (
                                <li className={'resourceList'} key={i}>
                                    <a href={item.url} className={'fontBrown'} target="_blank">{item.title}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            :
            <div className={`${style.resources}`}>
                <h4 className={`${style.subHeaderPlus} fontTisa`}>{t('resources')}</h4>
                <ul>
                    {data.map((item, i) => (
                        <li className={'resourceList'} key={i}>
                            <a href={item.url} className={'fontBrown'} target="_blank">{item.title}</a>
                        </li>
                    ))}
                </ul>
            </div>
    }
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Course/CoursePresentation.js